// extracted by mini-css-extract-plugin
module.exports = {"control":"AttendeeSelector_control_wGHwV","body":"AttendeeSelector_body_1UgGk"};